<div class="driver-shell">
    <driver-simulation-selector class="driver-shell__sim"></driver-simulation-selector>
    <div class="driver-app driver-shell__frame">
        <main class="driver-scr" [class.driver-scr--flush]="contentFlush">
            <router-outlet></router-outlet>
        </main>
        <app-driver-tab-bar *ngIf="showTabBar" [activeTab]="activeTab"></app-driver-tab-bar>
    </div>
</div>
